import { Plane, Briefcase, Landmark, Sparkles } from "lucide-react";

export const COMPANY = {
  name: "Admiral Limousine Service",
  short: "ADMIRAL",
  city: "Washington, DC",
  email: "info@admirallimoservice.com",
  address: "P.O. Box 3511 Washington, DC 20027",
  phones: [
    { label: "Office", number: "1 (202) 779-6054", tel: "+12027796054" },
    { label: "Virginia", number: "1 (703) 979-6664", tel: "+17039796664" },
    { label: "Dispatch", number: "1 (202) 232-4440", tel: "+12022324440" },
  ],
};

export const PRIMARY_TEL = COMPANY.phones[0].tel;

export const LOGO_EMBLEM = "/logo-crest.png";

export const HERO_LINES = ["Ride in Style,", "Arrive in", "Excellence."];

export const STATS = [
  { value: "1000+", label: "Active Riders" },
  { value: "1M+", label: "Rides Taken" },
  { value: "4.9", label: "Avg. Rating" },
  { value: "24/7", label: "Availability" },
];

export const SERVICES = [
  {
    id: "airport",
    icon: Plane,
    title: "Airport Transportation",
    desc: "Seamless, punctual transfers across the DMV — IAD, DCA & BWI. Flight tracking, meet & greet, zero stress.",
    span: "md:col-span-7",
    image:
      "https://images.unsplash.com/photo-1771775751121-3091d79073d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "corporate",
    icon: Briefcase,
    title: "Corporate Travel",
    desc: "Discreet, professional transportation for executives and business delegations.",
    span: "md:col-span-5",
    image:
      "https://images.unsplash.com/photo-1764269712999-e32acce1f277?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "tourism",
    icon: Landmark,
    title: "Tourism & Sightseeing",
    desc: "Discover the monuments and hidden gems of the capital in absolute comfort.",
    span: "md:col-span-5",
    image:
      "https://images.unsplash.com/photo-1585552361253-bd27dfc50c10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "events",
    icon: Sparkles,
    title: "Special Events",
    desc: "Weddings, galas & red-carpet nights — arrive with unmistakable elegance and a chauffeur who anticipates every need.",
    span: "md:col-span-7",
    image:
      "https://images.unsplash.com/photo-1564890379653-0eb3a6b4eaad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

const IMG = "/fleet";

export const FLEET = [
  {
    name: "Mercedes-Benz S-Class",
    klass: "Executive Sedan",
    seats: "Up to 3 Passengers",
    desc: "The definitive statement in business travel — whisper-quiet, impeccably appointed.",
    image: `${IMG}/sclass.png`,
  },
  {
    name: "Cadillac CT4",
    klass: "Luxury Sedan",
    seats: "Up to 3 Passengers",
    desc: "Sharp American elegance for airport runs and city transfers with effortless style.",
    image: `${IMG}/ct4.png`,
  },
  {
    name: "Cadillac Escalade",
    klass: "Luxury SUV",
    seats: "Up to 6 Passengers",
    desc: "Commanding presence and generous space for executives and families alike.",
    image: `${IMG}/escalade.png`,
  },
  {
    name: "Lincoln Navigator",
    klass: "Premium SUV",
    seats: "Up to 6 Passengers",
    desc: "Refined comfort with a first-class cabin — the pinnacle of American luxury SUVs.",
    image: `${IMG}/navigator.png`,
  },
  {
    name: "Mercedes Sprinter",
    klass: "Executive Van",
    seats: "Up to 14 Passengers",
    desc: "Move your team together in first-class comfort with room to breathe.",
    image: `${IMG}/sprinter.png`,
  },
  {
    name: "Luxury Motorcoach",
    klass: "Group Charter",
    seats: "Up to 56 Passengers",
    desc: "Full-size charter coach for large groups, conferences and tour itineraries.",
    image: `${IMG}/motorcoach.png`,
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Instantly book & be on your way.",
    body: "Whether you're headed to a business meeting, a special event, or a reliable airport transfer, our professional chauffeurs ensure your ride is smooth, safe and stylish.",
  },
  {
    no: "02",
    title: "Take control of your ride.",
    body: "Simple, secure and convenient. Our platform is available 24/7, so you can rely on us for last-minute travel needs at any hour of the day.",
  },
  {
    no: "03",
    title: "Safety & efficiency, always.",
    body: "We prioritize customer safety above all — vetted chauffeurs, immaculately maintained vehicles, and routes planned to the minute.",
  },
];

export const FAQ = [
  {
    q: "What types of vehicles do you offer?",
    a: "Our fleet ranges from executive Mercedes-Benz sedans and luxury SUVs to stretch limousines and Sprinter vans, accommodating everything from solo executives to groups of fourteen.",
  },
  {
    q: "How do I make a reservation?",
    a: "Book instantly through our online form above, or call our dispatch line 24/7. You'll receive confirmation with your chauffeur's details ahead of pickup.",
  },
  {
    q: "Do you provide airport transfers?",
    a: "Yes. We serve IAD (Dulles), DCA (Reagan National) and BWI with real-time flight tracking, meet-and-greet service and complimentary wait time.",
  },
  {
    q: "Is there a minimum rental time?",
    a: "Hourly bookings typically start at a two-hour minimum, while point-to-point transfers are priced per trip. Our team will confirm details at booking.",
  },
  {
    q: "Can I request special amenities in the vehicle?",
    a: "Absolutely. From bottled water and phone chargers to child seats and specific music preferences, let us know and we'll prepare the vehicle to your liking.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1771775751121-3091d79073d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const SAFETY_IMAGE =
  "https://images.unsplash.com/photo-1742247329326-501cb774c94f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const SERVICE_TYPES = [
  "Airport Transportation",
  "Corporate Travel",
  "Tourism & Sightseeing",
  "Special Events",
  "Point to Point",
];
